export enum PillTypes {
  severity = 'severity',
  status = 'status',
  policy = 'policy',
}